import { render } from "./slide-6.vue?vue&type=template&id=c545ea5a&scoped=true"
import script from "./slide-6.vue?vue&type=script&lang=js"
export * from "./slide-6.vue?vue&type=script&lang=js"

import "./slide-6.vue?vue&type=style&index=0&id=c545ea5a&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c545ea5a"]])

export default __exports__